import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { makeStyles, styled } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { globalStyles } from 'GlobalStyles';
import { flexAlignCenterSpaceAround, flexAlignEnd } from 'UI/utils/styles';

export const useStyles = makeStyles(theme => ({
  skeletonBar: {
    width: '100%',
    backgroundColor: theme.palette.grey[300],
    height: 132,
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    ...flexAlignCenterSpaceAround
  },
  dotBarContainer: {
    justifyContent: 'flex-end',
    width: '95%',
    flexGrow: 1,
    ...flexAlignEnd
  },
  headerItemsBar: {
    flexGrow: 2,
    ...globalStyles.skeletonContainer,
    margin: 0
  },
  rowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.25, 2.5),
    backgroundColor: theme.palette.customColors.appBackgroundContrast
  },
  footerSkeletonBar: {
    marginTop: theme.spacing(2)
  },
  skeletonItemContainer: {
    width: '100%'
  },
  skeletonItem: {
    ...globalStyles.profileSkeletonItem
  },
  skeletonRow: {
    ...globalStyles.skeletonContainer
  }
}));

export const HeaderSkeletonRoot = styled(Paper)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'flex-start',
  padding: theme.spacing(3, 4),
  width: '100%'
}));

export const CellSkeleton = styled(Box)(({ theme }) => ({
  flex: 1,
  marginRight: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  '&:last-child': {
    marginRight: 0
  }
}));

export const CircleSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: '50%',
  marginRight: theme.spacing(2.5)
}));
